'use client';
import React, { useCallback } from 'react';
import { SafeType } from '@benzinga/safe-await';
import { Authentication } from '@benzinga/session';

import { SMSVerify } from '../../components/SMSVerify';
import { AuthSurface } from '../types';

export interface SmsVerifySurfaceProps {
  authentication: SafeType<Authentication> | null;
  phoneNumber: string;
  parentSurface: Extract<AuthSurface, 'page' | 'regwall'>;
  onVerified?: (auth: SafeType<Authentication>) => void;
}

/**
 * Phone OTP verification step.
 * Does NOT emit AUTH_SUCCESS_EVENT — the parent surface (PageSurface / RegwallSurface)
 * owns the emit so consumers don't double-count. Standalone callers should emit from
 * their own onVerified handler.
 */
export const SmsVerifySurface: React.FC<SmsVerifySurfaceProps> = ({
  authentication,
  onVerified,
  parentSurface,
  phoneNumber,
}) => {
  const handleVerified = useCallback(
    (auth: SafeType<Authentication>) => {
      onVerified?.(auth);
    },
    [onVerified],
  );

  return (
    <div data-parent-surface={parentSurface} data-surface="sms-verify">
      <SMSVerify authentication={authentication} onVerified={handleVerified} phoneNumber={phoneNumber} />
    </div>
  );
};

SmsVerifySurface.displayName = 'SmsVerifySurface';
